module.exports = __webpack_public_path__ + "static/assets/ec035fe4952b14731cf5103020c2ae2f.svg";